module.exports = __webpack_public_path__ + "cf9595a7ae11cf46b1f4c47871adc351.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/cashier/close.png
// module id = 645
// module chunks = 0